



































import { Component, Vue } from 'vue-property-decorator'
import { BaseStore } from '@/store/modules/Base'
import { login } from '@/api/login'
import { UserStore } from '@/store/modules/User'
import { getUserInfo } from '@/api/user'
import { Encryption, Decode } from '@/utils/tool'

@Component({
  name: 'LoginForm'
})
export default class LoginForm extends Vue {
  private fullPath = ''

  private loading: any = null

  // 域名校验 -- 先只校验非空

  rules = {
    webSite: [
      { required: true, message: '请输入企业域名', trigger: 'blur' }
    ],
    userName: [
      { required: true, message: '请输入账户', trigger: 'blur' }
    ],
    userPwd: [
      { required: true, message: '请输入密码', trigger: 'blur' }
    ]
  }

  form = {
    webSite: process.env.NODE_ENV === 'development' ? 'yanshi.zowoyoo.com' : '',
    userName: '',
    userPwd: '',
    user: ''
  }

  private sendUrl = ''

  // 记住密码
  checked = false

  // 点击登录
  clickLogin (): void {
    console.log('登录')
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.$refs.form.validate((valid) => {
      if (valid) {
        this.APILogin()
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }

  //  调用API login
  private APILogin ():void {
    // 判断是否是记住密码状态
    if (this.checked) {
      // 加密
      const LoginInfo = Encryption(JSON.stringify(this.form))
      // u_lo 是用户输入的账户密码，如果用户点击了记住，就保存在本地，但是要加密一下
      localStorage.setItem('u_lo', LoginInfo)
    } else {
      localStorage.removeItem('u_lo')
    }
    this.loading = this.$loading({
      lock: true,
      text: '登录中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    login(this.form)
      .then((res: any) => {
        if (res.success) {
          BaseStore.SET_TOKEN(res.data.tokenData)
          const s = new Date().getTime() + (res.data.tokenData.expiresIn * 1000)
          BaseStore.SET_TOKEN_EXPIRES_IN(s)
          this.getUserInfo()
        } else {
          this.form.userPwd = ''
          this.loading.close()
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      }).catch(() => {
        this.loading.close()
      })
  }

  // 请求服务数据 用户信息
  private async getUserInfo () {
    const res = await getUserInfo()
    if (res.mchName) {
      BaseStore.SET_POP_UP(true)
      UserStore.SET_USER_INFO(res)
      setTimeout(() => {
        this.$notify({
          title: '登录',
          message: '登录成功',
          type: 'success'
        })
        this.loading.close()
        if (!this.sendUrl) {
          this.$router.replace({
            path: decodeURIComponent(this.fullPath) || '/home'
          })
        } else {
          window.location.replace(this.sendUrl)
        }
      }, 800)
    }
  }

  mounted (): void {
    // u_lo 是用户输入的账户密码，如果用户点击了记住，就保存在本地，但是要加密一下
    const LoginInfo = localStorage.getItem('u_lo')
    if (LoginInfo) {
      try {
        this.checked = true
        this.form = JSON.parse(Decode(LoginInfo))
      } catch {

      }
    }
  }

  created () {
    const { user, sendUrl, fullPath } = this.$route.query
    if (typeof fullPath === 'string') {
      this.fullPath = fullPath
    }
    if (sendUrl) this.sendUrl = sendUrl as string
    if (typeof user === 'string') {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      login({
        user: encodeURIComponent(decodeURIComponent(user))
      })
        .then((res: any) => {
          if (res.success) {
            BaseStore.SET_TOKEN(res.data.tokenData)
            const s = new Date().getTime() + (res.data.tokenData.expiresIn * 1000)
            BaseStore.SET_TOKEN_EXPIRES_IN(s)
            this.getUserInfo()
          } else {
            this.form.userPwd = ''
            this.loading.close()
            this.$message({
              message: res.msg,
              type: 'error'
            })
          }
        }).catch(() => {
          this.loading.close()
        })
    }
  }
}
